export const TIPOS_TESTE = [
  { value: 'respiratorio', label: 'Respiratório', icon: 'bi-lungs' },
  { value: 'auditivo',     label: 'Auditivo',     icon: 'bi-ear'   },
];

export const GRUPOS_TESTE = {
  respiratorio: [
    { value: 'qualitativo',  label: 'Qualitativo' },
    { value: 'quantitativo', label: 'Quantitativo' },
  ],
  auditivo: [
    { value: 'objetivo',   label: 'Objetivo' },
    { value: 'subjetivo',  label: 'Subjetivo' },
  ],
};

export const tipoIcon = (tipo) => tipo === 'auditivo' ? 'bi-ear' : 'bi-lungs';
export const isRespiratorio = (tipo) => tipo === 'respiratorio';
export const tipoLabel = (tipo) => TIPOS_TESTE.find(t => t.value === tipo)?.label || tipo;

export const TIPOS_PROTETOR_AURICULAR = [
  'TIPO PLUG',
  'TIPO INSERÇÃO',
  'TIPO CONCHA',
  'TIPO PLUG + TIPO CONCHA',
  'TIPO INSERÇÃO + TIPO CONCHA',
];

export const NIVEIS_ATENUACAO = [
  'ATENUAÇÃO EXCESSIVA (<70dB(A))',
  'ATENUAÇÃO ACEITÁVEL (70.1 a 75 dB(A))',
  'ATENUAÇÃO IDEAL (75.1 a 79.9 dB(A))',
  'ATENUAÇÃO ACEITÁVEL LIMÍTROFE (80 a 84.9 dB(A))',
  'ATENUAÇÃO INSUFICIENTE (>85dB(A))',
];

export const RESULTADOS = ['APROVADO', 'REPROVADO', 'REFAZER'];

export const TIPOS_LOCAL = [
  'Local',
  'Plataforma',
  'Base',
  'Escritório',
  'Estaleiro',
  'Terminal',
  'Outro',
];
